import { Box, Flex, IconButton, NativeSelect } from '@chakra-ui/react';
import { FaUndo } from 'react-icons/fa';
import { LessonWithClient } from './LessonsController';
import { uniq } from 'lodash';
import { useEffect, useState } from 'react';

export type LessonsHeaderProps = {
	lessons: LessonWithClient[];
	onFilter: React.Dispatch<React.SetStateAction<LessonWithClient[]>>;
}

function LessonsHeader({
	lessons,
	onFilter,
}: LessonsHeaderProps) {
	const teachers = uniq(lessons.map((l) => l.teacher)).sort();
	const codes = uniq(lessons.map((l) => l.code)).sort();
	const clients = uniq(lessons.flatMap((l) => l.students.map((s) => s.client))).sort()

	const [codeFilter, setCodeFilter] = useState('');
	const [teacherFilter, setTeacherFilter] = useState('');
	const [clientFilter, setClientFilter] = useState('');
	const [locationFilter, setLocationFilter] = useState('');

	const clearFilters = () => {
		setCodeFilter('');
		setTeacherFilter('');
		setClientFilter('');
		setLocationFilter('');
	};

	useEffect(() => {
		let filteredLessons: any[] = lessons.reduce((acc, lesson) => {
			if (codeFilter && lesson.code !== codeFilter) return acc;
			if (teacherFilter && lesson.teacher !== teacherFilter) return acc;
            if (clientFilter && !lesson.students.some((s) => s.uid === clientFilter)) return acc;
			if (locationFilter && lesson.location !== locationFilter) return acc;
			return [...acc, lesson];
		}, [] as LessonWithClient[]);

		onFilter(filteredLessons);
	}, [
		lessons,
		onFilter,
		codeFilter,
		teacherFilter,
		clientFilter,
		locationFilter,
	]);

	// const hasAnyFilters =
	// 	codeFilter || teacherFilter || clientFilter || locationFilter;

	return (
        <Box>
            <Flex>
				<NativeSelect.Root>
                    <NativeSelect.Field
                        placeholder="Kod"
                        value={codeFilter}
                        onChange={(event) => setCodeFilter(event.target.value)}
                        // variant={codeFilter ? 'filled' : 'flushed'}
                        m={1}>
                        {codes.map((code: string) => (
                            <option key={code} value={code}>
                                {code}
                            </option>
                        ))}
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                </NativeSelect.Root>
				<NativeSelect.Root>
                    <NativeSelect.Field
                        placeholder="Korepetytor"
                        value={teacherFilter}
                        onChange={(event) => setTeacherFilter(event.target.value)}
                        // variant={teacherFilter ? 'filled' : 'flushed'}
                        m={1}>
                        {teachers.map((teacherName: string) => (
                            <option key={teacherName} value={teacherName}>
                                {teacherName}
                            </option>
                        ))}
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                </NativeSelect.Root>
				<NativeSelect.Root>
                    <NativeSelect.Field
                        placeholder="Klient"
                        value={clientFilter}
                        onChange={(event) => {
                            setClientFilter(event.target.value);
                        }}
                        // variant={clientFilter ? 'filled' : 'flushed'}
                        m={1}>
                        {clients.map((c) => (<option key={c.uid} value={c.uid}>{c.name}</option>))}
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                </NativeSelect.Root>
				<NativeSelect.Root>
                    <NativeSelect.Field
                        placeholder="Miejsce"
                        value={locationFilter}
                        onChange={(event) => {
                            setLocationFilter(event.target.value);
                        }}
                        // variant={locationFilter ? 'filled' : 'flushed'}
                        m={1}>
                        <option value="Cynamonowa">Cynamonowa</option>
                        <option value="Lanciego">Lanciego</option>
                        <option value="online">online</option>
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                </NativeSelect.Root>
				<IconButton
                    onClick={clearFilters}
                    aria-label="Wyczyść filtry"
                    // variant={hasAnyFilters ? 'solid' : 'outline'}
                    m={1}><FaUndo /></IconButton>
			</Flex>
        </Box>
    );
}

export default LessonsHeader